<template>
  <button type="button"
    class="bg-secondary text-secondary-foreground border border-border h-12 items-center rounded-sm font-bold flex justify-center transition-all hover:bg-secondary/80"
    :class="[$slots.icon ? 'px-4' : 'px-6']">
    <div class="mr-2" v-if="$slots.icon">
      <slot name="icon" />
    </div>
    <slot />
  </button>
</template>